import { render, staticRenderFns } from "./plateAll.vue?vue&type=template&id=2fa1cdad&scoped=true&"
import script from "./plateAll.vue?vue&type=script&lang=js&"
export * from "./plateAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa1cdad",
  null
  
)

export default component.exports